module.exports = __webpack_public_path__ + "static/media/automation.5ee9583c.svg";